import type { AgentDetail } from './types';

export const agentFixtures: readonly AgentDetail[] = Object.freeze([
  Object.freeze({
    id: '00000000-0000-4000-8000-000000000401',
    partnerId: '00000000-0000-4000-8000-000000000101',
    code: 'AGT-A',
    name: 'Alpha Agent',
    contact: Object.freeze({ email: 'agent-a@example.test' }),
    status: 'ACTIVE',
    isCenterAgent: true,
    defaultCurrencyCode: 'THB',
    defaultUpline: Object.freeze({
      memberId: '00000000-0000-4000-8000-000000000501',
      username: 'house.alpha',
      referralCode: 'REF_01HJKMNPQRSTVWXY',
    }),
    userCount: 24,
    activeUserCount: 12,
    createdAt: '2026-07-20T10:00:00+07:00',
    createdBy: '00000000-0000-4000-8000-000000000001',
    updatedAt: '2026-07-22T12:00:00+07:00',
    updatedBy: '00000000-0000-4000-8000-000000000001',
  }),
  Object.freeze({
    id: '00000000-0000-4000-8000-000000000402',
    partnerId: '00000000-0000-4000-8000-000000000102',
    code: 'AGT-B',
    name: 'Beta Agent',
    contact: Object.freeze({}),
    status: 'SUSPENDED',
    isCenterAgent: false,
    defaultCurrencyCode: 'USD',
    defaultUpline: null,
    userCount: 0,
    activeUserCount: 0,
    createdAt: '2026-07-18T03:00:00Z',
    createdBy: '00000000-0000-4000-8000-000000000001',
    updatedAt: '2026-07-21T04:30:00Z',
    updatedBy: '00000000-0000-4000-8000-000000000001',
  }),
]);
